<template>
    <div class="practice-admin mb-3 mt-page">

        <b-row>
            <b-col>
                <h1>
                    {{ pageTitle }}
                </h1>
            </b-col>
            <b-col class="text-right">
                <router-link class="btn btn-ghost-blue mr-1"
                             :to="resellerId && companyId ? `/practice/create/companyId/${companyId}/resellerAdmin/${this.resellerId}` : `/practice/create/companyId/${companyId}`">
                    <shs-icon name="plus"></shs-icon>
                    {{ $i18n.gt('LABEL_NEW_PRACTICE') }}
                </router-link>
            </b-col>
        </b-row>

        <data-table ref="dataTable"
                    :show-filters="true"
                    :show-pager="true"
                    :show-details="$user.roleIsAdmin()"
                    :get-items="getPractices"
                    :filters="filters"
                    :fields="fields">

            <!-- template for custom columns -->
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key == 'name'">
                    {{ slotProps.row.item.name }}
                    <b-badge variant="danger" class="ml-3"
                             v-if="slotProps.row.item.disabled">
                        {{ $i18n.gt('LABEL_DISABLED') }}
                    </b-badge>
                </div>
                <div v-else-if="slotProps.row.field.key == 'actions'">
                    <router-link class="btn btn-secondary btn-sm mr-2"
                                 :to="resellerId ?
                                 `/practice/update/resellerAdmin/${resellerId}/companyId/${slotProps.row.item.company_id}/id/${slotProps.row.item.id}` :
                                 `/practice/update/companyId/${slotProps.row.item.company_id}/id/${slotProps.row.item.id}`">
                        <shs-icon name="pencil"></shs-icon>
                    </router-link>
                    <b-btn size="sm"
                           variant="danger"
                           @click="deletePractice(slotProps.row.item)">
                        <shs-icon name="delete"></shs-icon>
                    </b-btn>
                </div>
                <div v-else-if="slotProps.row.field.key == 'type'">
                    {{ getTypesDisplay(slotProps.row.item.type) }}
                </div>
                <div v-else>
                    {{ slotProps.row.item[slotProps.row.field.key] }}
                </div>
            </template>

            <!-- template for custom row details -->
            <template v-slot:customRowDetails="slotProps">
                <div class="float-right ml-3"
                     v-if="$user.roleIsAdmin()">
                    <router-link class="btn btn-primary"
                                 :to="`/practitioner/admin/companyId/${slotProps.row.item.company_id}/practiceId/${slotProps.row.item.id}`">
                        {{ $i18n.gt('LABEL_PRACTITIONERS') }}
                    </router-link>
<!--                    <router-link class="btn btn-primary ml-3"-->
<!--                                 :to="`/practice/aggregateReport/id/${slotProps.row.item.id}`">-->
<!--                        {{ $i18n.gt('LABEL_QUESTION_STATISTICS') }}-->
<!--                    </router-link>-->
                </div>
            </template>

        </data-table>

    </div>
</template>

<script>

import Vue from 'vue'
import * as _ from 'lodash'

/**
 * Page for admin to manage Practices
 */
export default Vue.extend({
    name: 'PracticeAdmin',
    props: {
        companyId: Number,
        resellerId: Number,
    },
    data() {
        return {
            company: {},
            typeOptions: [
                {value: 'PRIMARY', text: 'Primary Care'},
                {value: 'SPECIALIST', text: 'Specialist'},
                {value: 'COACH', text: 'Health and Wellness Coach'},
                {value: 'MENTOR', text: 'Health Mentor'},
            ],
            fields: [
                {key: 'name', sortable: true},
                {key: 'city', sortable: true},
                {key: 'state', sortable: true},
                {key: 'type', sortable: true},
                {key: 'actions', sortable: false},
            ],
        }
    },
    computed: {
        filters() {
            return {
                'company_id': {
                    field: 'company_id', type: 'hidden',
                    value: this.companyId, options: this.companies, label: 'Company'
                },
                name: {field: 'name', type: 'string', value: null, label: 'Name'},
                city: {field: 'city', type: 'string', value: null, label: 'City'},
                state: {field: 'state', type: 'string', value: null, label: 'State'},
                type: {field: 'type', type: 'select', value: null, label: 'Type', options: this.typeOptions},
            }
        },
        pageTitle() {
            return this.$i18n.gt('HEADING_MANAGE_PRACTICES_FOR') + ' ' + (this.company.name ? this.company.name : 'Company')
        }
    },
    methods: {
        getTypesDisplay(types) {
            return _.map(types.split(','), (t) => {
                const typeOption = _.find(this.typeOptions, (to) => {
                    return to.value == t
                })
                return (typeOption ? typeOption.text : '')
            }).join(', ')
        },
        getPractices(listParams) {
            return this.$api.getItems(this, 'practice', this.filters, listParams)
        },
        async deletePractice(practice) {
            if (await this.$bvModal.msgBoxConfirm(`Delete practice ${practice.name} permanently from the database?`)) {
                try {
                    await this.$api.deleteItem(this, 'practice', practice)
                    this.$toasted.show('Practice deleted', {duration: 3000})
                    this.$refs.dataTable.refresh()
                } catch (e) {
                    this.$utils.handleError(e, 'Error deleting practice')
                }
            }
        }
    },
    mounted() {
        this.$api.getItem(this, 'company', this.companyId)
            .then((item) => {
                this.company = item
            })
    }
})

</script>
